import React from 'react';
import { Form, Input } from 'antd';
import './style.scss'

const TextAreaAntd = ({ placeholder, customClass, name, isRequired, rows }) => {

  let rules = [];
  if (isRequired) {
    rules = [
      {
        required: true,
        message: 'Trường bắt buộc không được để trống',
      },
      ...rules,
    ]
  }

  return (
    <Form.Item className={`area-antd ${customClass || ''}`}>
      <Form.Item name={name} noStyle rules={rules}>
        <Input.TextArea
          placeholder={placeholder}
          className="custom-input"
          rows={rows}
        />
      </Form.Item>
    </Form.Item>
  );
}

TextAreaAntd.defaultProps = {
  isRequired: true,
};

export default React.memo(TextAreaAntd);